import { getCurrentShellBasePath } from "lib/routes/current-shell-path"

export function getReviewProjectsRootPath(topLevelPath) {
    return `${getCurrentShellBasePath(topLevelPath)}/review-projects`
}

export function getReviewProjectPath(projectId, topLevelPath) {
    return `${getReviewProjectsRootPath(topLevelPath)}/${encodeURIComponent(projectId)}`
}

export function getReviewProjectTabPath(projectId, tab, topLevelPath) {
    return `${getReviewProjectPath(projectId, topLevelPath)}?tab=${encodeURIComponent(tab)}`
}

export function getReviewProjectRunPath(projectId, runId, topLevelPath) {
    return `${getReviewProjectPath(projectId, topLevelPath)}/runs/${encodeURIComponent(runId)}`
}

export function getReviewProjectRunResolutionPath({ projectId, runId, scheduleId }, topLevelPath) {
    return `${getReviewProjectRunPath(projectId, runId, topLevelPath)}/schedule/${encodeURIComponent(scheduleId)}`
}
